type ProcessedPaymentDtoAttributes = {
    accountId: string,
    amount: string,
    amountFeeCollected: string,
    amountPaidToMerchant: string,
    currency: string,
    declinedReason: string,
    externalId: string,
    paymentAccountId: string,
    paymentId: string,
    paymentMethodId: string,
    paymentProcessorKey: string,
    status: string,
    terminalId: string,
    type: string,
    usePaymentMethodOnFile: boolean
}

export type ProcessedPaymentDto = {
    id: string
    type: string
    attributes: ProcessedPaymentDtoAttributes
}

export enum PROCESSED_PAYMENT_STATUS {
    CREATED = "CREATED",
	PRESENTING = "PRESENTING",
	PROCESSING = "PROCESSING",
	SUCCEEDED = "SUCCEEDED",
	FAILED = "FAILED",
	CANCELED = "CANCELED",
	IN_REVIEW = "IN_REVIEW",
	REFUNDED = "REFUNDED",
	PARTIALLY_REFUNDED = "PARTIALLY_REFUNDED",
}

export default class ProcessedPayment {
    private dto: ProcessedPaymentDto
    constructor(dto: ProcessedPaymentDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.getId() != "" && this.dto.type == "processed-payments"
    }

    getId(): string {
        return this.dto.id
    }

    getStatus(): PROCESSED_PAYMENT_STATUS {
        return this.dto.attributes.status as PROCESSED_PAYMENT_STATUS
    }

    getPaymentId(): string {
        return this.dto.attributes.paymentId
    }

    isPaymentApproved(): boolean {
        return [
            PROCESSED_PAYMENT_STATUS.PROCESSING,
            PROCESSED_PAYMENT_STATUS.SUCCEEDED,
            PROCESSED_PAYMENT_STATUS.PARTIALLY_REFUNDED,
        ].includes(this.getStatus())
    }

    isPaymentProcessing(): boolean {
        return this.getStatus() === PROCESSED_PAYMENT_STATUS.PROCESSING
    }
}


// WEBPACK FOOTER //
// ./src/payment-account/model/ProcessedPayment.ts